import { useEffect, useState } from "react";

/** Cloudinary image when set on the pose, otherwise nothing. */
export default function PoseFigure({ pose, imgClassName, wrapClassName }) {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [pose.sanskrit, pose.imageUrl]);

  if (!pose.imageUrl || imageFailed) {
    return <span className={wrapClassName} aria-hidden />;
  }

  return (
    <img
      src={pose.imageUrl}
      alt={pose.sanskrit}
      className={imgClassName}
      onError={() => setImageFailed(true)}
    />
  );
}
